import { render, staticRenderFns } from "./mobile-change.vue?vue&type=template&id=800b6098&scoped=true&"
import script from "./mobile-change.vue?vue&type=script&lang=js&"
export * from "./mobile-change.vue?vue&type=script&lang=js&"
import style0 from "./mobile-change.vue?vue&type=style&index=0&id=800b6098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800b6098",
  null
  
)

export default component.exports